import React from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { clearMaintenanceMode } from '../../store/appSlice'
import { checkSystemStatus } from '../../api/system'

export const MaintenanceBanner: React.FC = () => {
  const dispatch = useAppDispatch()
  const { isMaintenanceMode, maintenanceMessage } = useAppSelector((state) => state.app)

  if (!isMaintenanceMode) return null

  const handleCheckStatus = async () => {
    try {
      const res = await checkSystemStatus()
      if (res.status === 'ok' && !res.maintenance) {
        dispatch(clearMaintenanceMode())
      }
    } catch {
      // Keep maintenance mode active
    }
  }

  return (
    <div className="bg-amber-500 text-slate-950 px-4 py-2 text-xs font-semibold flex items-center justify-between shadow-md z-50 sticky top-0">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 text-slate-950 flex-shrink-0 animate-bounce" />
        <span>
          <strong>SUPER ADMIN ACCESS MODE:</strong> System is currently under maintenance for regular users ({maintenanceMessage})
        </span>
      </div>
      <button
        onClick={handleCheckStatus}
        className="inline-flex items-center gap-1 bg-slate-950/20 hover:bg-slate-950/30 text-slate-950 px-2.5 py-1 rounded font-medium transition cursor-pointer"
      >
        <RefreshCw className="w-3 h-3" /> Re-check Status
      </button>
    </div>
  )
}

export default MaintenanceBanner
